module.exports = __webpack_public_path__ + "img/welcome-to-apvertise-p-500.34548be2.png";